var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e11e5a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.933,11.711,15.622,15l3.289,3.289a.43.43,0,0,1,0,.622.43.43,0,0,1-.622,0L15,15.622l-3.289,3.311a.43.43,0,0,1-.622,0,.43.43,0,0,1,0-.622L14.378,15l-3.311-3.289a.44.44,0,0,1,.622-.622L15,14.378l3.289-3.289a.43.43,0,0,1,.622,0A.412.412,0,0,1,18.933,11.711ZM25,15A10,10,0,1,1,15,5,10.015,10.015,0,0,1,25,15Zm-.889,0A9.111,9.111,0,1,0,15,24.111,9.124,9.124,0,0,0,24.111,15Z",
    transform: "translate(-5 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.165eb1f941fc3288403e3dc1dede3cde.svg";
export { ForwardRef as ReactComponent };